(function(){
'use strict';

// Product Personalizer inserts the LETRA field asynchronously. Always position
// this option immediately before the genuine add-to-cart control, after LETRA.
function positionCuff(){
 document.querySelectorAll('.anitials-cuff-after-personalizer').forEach(wrapper=>{
  const root=wrapper.querySelector('[data-ani-cuff]');if(!root)return;
  const form=document.getElementById(root.dataset.formId);
  if(!form)return;
  const holder=form.querySelector('.product__submit__holder');
  if(!holder||wrapper.nextElementSibling===holder)return;
  holder.parentElement.insertBefore(wrapper,holder);
 });
}
let positionQueued=false;
function schedulePosition(){
 if(positionQueued)return;
 positionQueued=true;
 requestAnimationFrame(()=>{positionQueued=false;positionCuff();});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>{
 positionCuff();new MutationObserver(schedulePosition).observe(document.querySelector('main')||document.body,{childList:true,subtree:true});
});else{
 positionCuff();new MutationObserver(schedulePosition).observe(document.querySelector('main')||document.body,{childList:true,subtree:true});
}

const variantIDs={'Sin-Derecho':53067320459604,'Sin-Izquierdo':53071212380500,'Con-Derecho':53067320426836,'Con-Izquierdo':53071212347732};
function field(el,s){return el.querySelector(s)}
document.addEventListener('change',e=>{
 const root=e.target.closest('[data-ani-cuff]');if(!root)return;
 const locale=(document.documentElement.lang||'es').toLowerCase();
 const lang=locale.startsWith('en')?'en':locale.startsWith('de')?'de':'es';
 const amount=field(root,'[data-cuff-heart]').value==='Con'?'15':'11';
 field(root,'[data-cuff-price]').textContent=lang==='en'?`Extra charge: +€${amount}.00`:lang==='de'?`Aufpreis: +${amount},00 €`:`Suplemento: +${amount},00 €`;
 field(root,'[data-cuff-text]').required=field(root,'[data-cuff-enabled]').checked;
 field(root,'[data-cuff-error]').hidden=true;
});
async function handleCuffPurchase(e, form){
 const roots=[...document.querySelectorAll('[data-ani-cuff]')];
 const scope=form.closest('[data-section-type="product-template"]')||form.closest('.product-single')||document;
 const root=roots.find(x=>scope.contains(x) && x.getClientRects().length>0) || roots.find(x=>x.dataset.formId===form.id && x.getClientRects().length>0);
 if(!root||!field(root,'[data-cuff-enabled]').checked)return;
 e.preventDefault();e.stopImmediatePropagation();
 if(form.dataset.aniCuffBusy==='true')return;
 const err=field(root,'[data-cuff-error]'),input=field(root,'[data-cuff-text]');
 const value=input.value.trim();
 if(!value||Array.from(value).length>3){err.textContent='Escribe entre 1 y 3 caracteres para el bordado.';err.hidden=false;input.focus();return;}
 const fd=new FormData(form);const baseId=Number(fd.get('id'));const quantity=Math.max(1,parseInt(fd.get('quantity')||'1',10));
 if(!baseId){err.textContent='Selecciona primero una variante disponible.';err.hidden=false;return;}
 const prop={};for(const [k,v] of fd.entries()){const m=/^properties\[(.+)\]$/.exec(k);if(m&&typeof v==='string'&&v.trim())prop[m[1]]=v;}
 // Product Personalizer can keep selection outside the Shopify form.
 // Require an explicit initial value or positively selected tile in the LETRA group.
 const productHost=form.closest('.product-single')||document;
 const letterFields=Object.entries(prop).filter(([name])=>/^(?:letra|inicial|letter)(?:\\s.*)?$/i.test(name.trim()));
 const fromProperty=letterFields.some(([,v])=>/^[a-zñ]$/i.test(String(v).trim()));
 const labelNodes=[...productHost.querySelectorAll('label,legend,span,div,p,strong,h3,h4')].filter(el=>el.children.length===0 && /^LETRA\\s*:?$/i.test((el.textContent||'').trim()));
 let selectedLetter=false;
 for(const label of labelNodes){
  let group=label.parentElement;
  for(let depth=0;group&&depth<4;depth++,group=group.parentElement){
   const options=[...group.querySelectorAll('input[type="radio"],input[type="checkbox"],button,[role="radio"],[aria-pressed],[aria-selected]')].filter(el=>/^[A-ZÑ]$/.test((el.textContent||el.value||el.getAttribute('aria-label')||'').trim()));
   if(options.length>=10){
    selectedLetter=options.some(el=>el.checked===true||el.getAttribute('aria-checked')==='true'||el.getAttribute('aria-pressed')==='true'||el.getAttribute('aria-selected')==='true'||el.classList.contains('selected')||el.classList.contains('active'));
    break;
   }
  }
  if(selectedLetter)break;
 }
 if(!fromProperty&&!selectedLetter){
  err.textContent='Selecciona primero la letra de tu sudadera.';
  err.hidden=false;
  (labelNodes[0]||productHost.querySelector('[class*="personaliz"]'))?.scrollIntoView({behavior:'smooth',block:'center'});
  return;
 }
 const key='cuff-'+Date.now().toString(36)+'-'+Math.random().toString(36).slice(2,8);
 prop['_Referencia extra puño']=key;
 const side=field(root,'[data-cuff-side]').value,heart=field(root,'[data-cuff-heart]').value;
 const extraId=variantIDs[heart+'-'+side];
 const addon={id:extraId,quantity,properties:{'Texto del puño':value,'_Referencia extra puño':key}};
 const button=form.querySelector('[data-add-to-cart]');form.dataset.aniCuffBusy='true';if(button)button.disabled=true;
 try{
 const route=(window.Shopify?.routes?.root||'/');
 const res=await fetch(route+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:baseId,quantity,properties:prop},addon]})});
 if(!res.ok){let detail=await res.json().catch(()=>null);throw Error(detail?.description||'No se pudieron añadir los dos artículos.');}
 document.dispatchEvent(new CustomEvent('theme:cart:refresh',{bubbles:true}));
 delete form.dataset.aniCuffBusy;
 if(button)button.disabled=false;
 }catch(error){err.textContent=error.message;err.hidden=false;delete form.dataset.aniCuffBusy;if(button)button.disabled=false;}
}
document.addEventListener('click',function(e){
 const button=e.target.closest('[data-add-to-cart]');if(!button)return;
 const form=button.form||button.closest('form');if(form)handleCuffPurchase(e,form);
},true);
document.addEventListener('submit',function(e){handleCuffPurchase(e,e.target);},true);
})();